export enum LeaderboardTypeEnum {
  ONLY_INDIVIDUALS = 'only_individuals',
  ONLY_GROUPS = 'only_groups',
  INDIVIDUALS_AND_GROUPS = 'individuals_and_groups'
}
